export const AI_GENERATING_TAG = 'ai-generating';

export function isTripGenerating(trip: { tags?: string[] | null }): boolean {
  return Boolean(trip.tags?.includes(AI_GENERATING_TAG));
}

/**
 * Single estimate, shown everywhere generation is mentioned.
 *
 * Measured, at last, against the deployed stack (`npm run time:plan -w
 * @travessa/api`): Белград 3 ночи — 12.6 мин, Чебоксары 5 — 14.8, Лиссабон 6 —
 * 17.8, Крит 8 — 26.1. It scales with the trip: research is half to two thirds
 * of it and every place costs three searches.
 *
 * So one range with the long end covered rather than the median. A three-night
 * trip beating the promise by two minutes is a good surprise; an eight-night
 * one overrunning it by six is the complaint this number exists to prevent.
 * The progress bar carries the rest — it knows how many stages are left, which
 * is more than any single figure can say.
 */
export const GENERATION_TIME_RANGE = '15–30 минут';
export const GENERATION_TIME_HINT = `Генерация обычно занимает ${GENERATION_TIME_RANGE}`;
